import { UIHeading4, UIHeading5 } from '@cian/ui-kit/typography';

import { PhoneButton } from 'shared/components/common/PhoneButton';
import type { IBuildingRepresentative } from 'shared/types/buildingCard';

import style from './style.css';

export interface IRepresentativeCardProps {
  representative: IBuildingRepresentative;
}

/** Официальный представитель — `contact_card.html` монолита; без лого — первая буква имени */
export const RepresentativeCard = ({ representative: { name, logoUrl, phones } }: IRepresentativeCardProps) => (
  <div className={style['container']} data-name="RepresentativeCard">
    <UIHeading5 as="h2">Официальный представитель</UIHeading5>
    <div className={style['content']}>
      <figure className={logoUrl ? style['logo'] : `${style['logo']} ${style['plain']}`}>
        {logoUrl ? (
          <img className={style['image']} src={logoUrl} alt={name ?? ''} />
        ) : (
          <span className={style['letter']} data-name="RepresentativeLetter">
            {(name ?? '').charAt(0).toUpperCase()}
          </span>
        )}
      </figure>
      <div className={style['info']}>
        <UIHeading4 as="h3">{name}</UIHeading4>
        <PhoneButton phones={phones} />
      </div>
    </div>
  </div>
);
